import * as React from 'react';

import {Link} from 'shells/link/link';
import type {Size} from 'shells/link/link';
import type {LinkVariant} from 'shells/link/types';

type Props = {
    variant?: LinkVariant;
    size?: Size;
    isEmbedded?: boolean;
};

export function PrivacyPolicy(props: Props) {
    return (
        <Link
            href='https://support.nutshell.com/en/articles/8428993-terms-conditions-nutshell-s-privacy-policy'
            size={props.size}
            variant={props.variant}
            newTab={true}
        >
            {props.isEmbedded ? 'Privacy policy' : 'Nutshell privacy policy'}
        </Link>
    );
}
